/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type AccountHolderType = 0 | 1;

export const AccountHolderType = {
    NUMBER_0: 0 as AccountHolderType,
    NUMBER_1: 1 as AccountHolderType
}